export default __webpack_public_path__ + "Meredith Murray.d94ab8e8b79bbee41ab3.png";